<template>
<div class="page">
   <Header></Header>
   <Main></Main>
   <Foot></Foot>
</div>
</template>
<script>
import Header from './components/Header.vue'
import Main from './components/Main.vue'
import Foot from './components/Foot.vue'
export default {
  components: { Header, Main, Foot },
  name: 'home',
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
</style>
